import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { PainSection } from '../components/sections/PainSection';
import { InsightSection } from '../components/sections/InsightSection';
import { SystemSection } from '../components/sections/SystemSection';
import { ImagineSection } from '../components/sections/ImagineSection';
import { CreatorSection } from '../components/sections/CreatorSection';
import { BonusesSection } from '../components/sections/BonusesSection';
import { InvestmentSection } from '../components/sections/InvestmentSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { StickyCTA } from '../components/ui/StickyCTA';
export function LandingPage() {
  return <main className="w-full overflow-x-hidden bg-ivory" data-id="element-245">
      <HeroSection data-id="element-246" />
      <PainSection data-id="element-247" />
      <InsightSection data-id="element-248" />
      <SystemSection data-id="element-249" />
      <ImagineSection data-id="element-250" />
      <CreatorSection data-id="element-251" />
      <BonusesSection data-id="element-252" />
      <InvestmentSection data-id="element-253" />
      <GuaranteeSection data-id="element-254" />
      <FAQSection data-id="element-255" />
      <FinalCTASection data-id="element-256" />

      <footer className="bg-plum-deep py-7 text-center" data-id="element-257">
        <p className="text-[11px] text-white/30 tracking-[0.05em]" data-id="element-258">
          © {new Date().getFullYear()} ProMind Energy. Todos los derechos
          reservados.
        </p>
      </footer>

      <StickyCTA data-id="element-259" />
    </main>;
}